import { useState } from 'react';

export const useTranslationToggle = (selectedHistory, isStreaming, streamingTranscript) => {
  // 🔥 번역문-원문 토글 상태 (디폴트: 번역문 표시)
  const [showTranslated, setShowTranslated] = useState(true);

  // 🔥 번역된 자막 우선 표시 로직 (토글 상태 반영)
  const getCurrentTranscript = () => {
    // 스트리밍 자막이 있으면 우선 사용 (isStreaming 여부와 관계없이)
    if (streamingTranscript) {
      return streamingTranscript;
    }
    
    if (!selectedHistory) {
      return '';
    }
    
    // 번역된 자막이 있는 경우에만 토글 적용
    if (selectedHistory.translatedTranscript) {
      if (showTranslated) {
        // 번역문 표시
        return selectedHistory.translatedTranscript;
      } else {
        // 원문 표시
        return selectedHistory.transcript || '';
      }
    }
    
    // 번역된 자막이 없으면 원본 자막 사용
    return selectedHistory.transcript || '';
  };
  
  const currentTranscript = getCurrentTranscript();
  
  // 번역문-원문 토글 핸들러
  const handleToggleTranslation = (checked) => {
    setShowTranslated(checked);
  };

  return {
    showTranslated,
    currentTranscript,
    handleToggleTranslation
  };
}; 